<template>
  <div class="dark-theme-container">
    <!-- 触发按钮 -->
    <el-button
        type="primary"
        @click="showComparison = true"
        :disabled="products.length < 2"
        class="comparison-btn"
    >
      <i class="el-icon-s-data"></i> {{ $t( 'CompareProductParameters') }}
    </el-button>
    <el-tooltip
        v-if="products.length < 2"
        effect="dark"
        content="请至少选择2个产品进行比较"
        placement="top"
    >
      <div slot="reference" style="display: inline-block;"></div>
    </el-tooltip>

    <!-- 全屏弹窗 -->
    <el-dialog
        :visible.sync="showComparison"
        title="产品参数比较"
        :fullscreen="true"
        :close-on-click-modal="false"
        :show-close="true"
        custom-class="fullscreen-comparison-modal"
    >
      <div class="comparison-content">
        <!-- 产品信息概览 -->
        <el-row :gutter="20" class="product-overview">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="(product, index) in products" :key="product.productId">
            <el-card shadow="hover" class="product-card">
              <div class="product-info">
                <div class="product-image">
                  <el-image
                      v-if="product.picture"
                      :src="$VUE_APP_BASE_API + product.picture"
                      :alt="product.productName"
                      fit="contain"
                  >
                    <div slot="error" class="image-error">
                      <i class="el-icon-picture-outline"></i>
                    </div>
                  </el-image>
                </div>
                <div class="product-details">
                  <h3>{{ product.productName }}</h3>
                  <p><strong>{{ $t( 'model') }}：</strong>{{ product.model }}</p>
                  <p><strong>{{ $t( 'type') }}：</strong>{{ product.typeName }}</p>
<!--                  <p><strong>创建时间：</strong>{{ formatDate(product.createTime) }}</p>-->
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

        <!-- 数据表格 -->
        <el-card class="table-card" shadow="hover" style="margin-top: 20px;">
          <el-table
              :data="comparisonData"
              border
              style="width: 100%;"
              class="dark-table"
          >
            <el-table-column
                prop="name"
                label="参数"
                align="center"
                width="200"
            ></el-table-column>
            <el-table-column
                v-for="(product, index) in products"
                :key="product.productId"
                :label="product.model"
                align="center"
            >
              <template slot-scope="scope">
                <span
                    :class="{ 'different-value': isDifferent(scope.row.key, index) }"
                >
                  {{ scope.row.values[index] || '-' }}
                </span>
              </template>
            </el-table-column>
          </el-table>
        </el-card>
		<div>
		   <ChartLine
		     :title="chartTitle"
				   	:chartType="chartType"
		     :chart-data="chartData"
		     :x-axis-name="xAxisName"
		     :y-axis-name="yAxisName"
		     :x-axis-max="xAxisMax"
		   />
		 </div>
		 
		 <div>
		    <ChartLine
		      :title="chartTwoTitle"
					:chartType="chartTwoType"
		      :chart-data="chartTwoData"
		      :x-axis-name="xTwoAxisName"
		      :y-axis-name="yTwoAxisName"
		      :x-axis-max="xTwoAxisMax"
		    />
		  </div>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button class="close-btn" @click="showComparison = false">{{ $t('close') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ChartLine from '../../../components/ChartLine.vue';
import { getProductAttributeGroups } from "@/api/sysytem/homePage";
export default {
  name: 'SpindleComparisonModal',
  components:{
  	  ChartLine
  },
  props: {
    products: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  data() {
    return {
      showComparison: false,
      parameterMap: {
        diameter: `${this.$t('productCompared.diameter')}`,
        maximumSpeed: `${this.$t('productCompared.maximumSpeed')}`,
        proInterface: `${this.$t('productCompared.proInterface')}`,
        bearingLubrication: `${this.$t('productCompared.bearingLubrication')}`,
        proPower: `${this.$t('productCompared.proPower')}`,
        proTorque: `${this.$t('productCompared.proTorque')}`,
      },
	  chartType:"nj",
    xAxisMax: 5000,
    chartData: [],
    chartTwoType:"gl",
    xTwoAxisMax: 5000,
    chartTwoData: [],
    chartLoading: false
    }
  },
  watch: {
    showComparison(val) {
      if (val) {
        this.fetchChartData();
      }
    },
    products: {
      handler() {
        if (this.showComparison) {
          this.fetchChartData();
        }
      },
      deep: true
    }
  },
  computed: {
    comparisonData() {
      const parameters = Object.keys(this.parameterMap);
      return parameters.map(paramKey => {
        return {
          key: paramKey,
          name: this.parameterMap[paramKey],
          values: this.products.map(product => product[paramKey])
        };
      });
    },
    chartTitle() {
      return this.$t('chart.torqueTitle')
    },
    chartTwoTitle() {
      return this.$t('chart.powerTitle')
    },
    xAxisName() {
      return this.$t('chart.speedAxis')
    },
    xTwoAxisName() {
      return this.$t('chart.speedAxis')
    },
    yAxisName() {
      return this.$t('chart.torqueAxis')
    },
    yTwoAxisName() {
      return this.$t('chart.powerAxis')
    }
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return date.toLocaleString();
    },
    hasDifference(paramKey) {
      const values = this.products.map(product => product[paramKey]);
      const stringValues = values.map(v => v?.toString() || '');
      return new Set(stringValues).size > 1;
    },
    isDifferent(paramKey, index) {
      if (!this.hasDifference(paramKey)) return false;
      const currentValue = this.products[index][paramKey]?.toString() || '';
      const otherValues = this.products
          .filter((_, i) => i !== index)
          .map(product => product[paramKey]?.toString() || '');
      return !otherValues.every(v => v === currentValue);
    },
    handleExport() {
      this.$message.success('导出功能已触发，实际项目中可在此实现导出逻辑');
    },
    fetchChartData() {
      if (!Array.isArray(this.products) || this.products.length === 0) {
        this.chartData = [];
        this.chartTwoData = [];
        return;
      }
      this.chartLoading = true;
      const requests = this.products.map((product, index) => {
        if (!product || !product.productId) {
          return Promise.resolve([]);
        }
        return getProductAttributeGroups(product.productId).then(res => {
          let data = res;
          if (res && res.code === 200 && Array.isArray(res.data)) {
            data = res.data;
          } else if (!Array.isArray(res)) {
            data = [];
          }

          if (data && Array.isArray(data) && data.length > 0) {
            data.forEach(group => {
              if (Array.isArray(group.valueList)) {
                group.valueList.forEach(item => {
                  const zsValue = Number(item.zs);
                  if (!isNaN(zsValue)) {
                    if (zsValue > this.xAxisMax) {
                      this.xAxisMax = zsValue;
                    }
                    if (zsValue > this.xTwoAxisMax) {
                      this.xTwoAxisMax = zsValue;
                    }
                  }
                });
              }
            });
          }

          const toNumber = (value, fallback = 0) => {
            const num = Number(value);
            return Number.isFinite(num) ? num : fallback;
          };
          return (data || []).map(group => {
            const prefix = product.model || product.productName || this.$t('chart.seriesPlaceholder');
            const groupName = group.name ? `${prefix} - ${group.name}` : prefix;
            const valueList = (group.valueList || group.attributeList || []).map(item => ({
              zs: toNumber(item.zs ?? item.shaftSpeed),
              gl: toNumber(item.gl ?? item.shaftPower),
              nj: toNumber(item.nj ?? item.torque)
            }));
            return {
              name: groupName,
              index,
              valueList
            };
          });
        }).catch(() => []);
      });

      Promise.all(requests).then(resultLists => {
        const merged = resultLists.flat().filter(item => item && item.valueList && item.valueList.length > 0);
        this.chartData = merged;
        this.chartTwoData = merged;
      }).finally(() => {
        this.chartLoading = false;
      });
    }
  }
}
</script>

<style scoped>
/* 根容器深色主题 */
.dark-theme-container {
/*  background-color: #151516;*/
  padding: 10px;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100px;
}

/* 触发按钮样式 */
  .comparison-btn {
    margin-bottom: 15px;
    width: 220px;
    height: 36px;
    background-color: #006BFF;
    border-color: #006BFF;
    font-size: 16px;
    font-weight: normal;
    display: flex;
    align-items: center;
    justify-content: center;
  }

.comparison-btn:hover {
  background-color: #0056CC;
  border-color: #0056CC;
}

/* 产品概览区域 */
.product-overview {
  margin-bottom: 15px;
}

.comparison-content{
  width: 80%;
  margin: 0 auto;
}
.product-card {
  background-color: #1e1e1e;
  border: 1px solid #2d2d2d;
  color: #e0e0e0;
}

.product-info {
  display: flex;
  align-items: center;
  background-color: #1e1e1e;
}

.product-image {
  width: 120px;
  height: 120px;
  margin-right: 15px;
  border: 1px solid #2d2d2d;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #151516;
  flex-shrink: 0; /* 防止图片被压缩 */
}

/* 窄屏时竖向布局 */
@media (max-width: 768px) {
  .product-info {
    flex-direction: column;
    align-items: center;
    padding: 10px;
  }
  
  .product-image {
    width: 100%;
    max-width: 200px;
    height: auto;
    aspect-ratio: 1;
    margin-right: 0;
    margin-bottom: 15px;
    align-self: center; /* 图片居中 */
  }
  
  .product-details {
    width: 100%;
    text-align: center; /* 文字居中 */
  }
  
  .product-details h3 {
    text-align: center;
    margin-bottom: 10px;
  }
  
  .product-details p {
    text-align: center;
    margin: 8px 0;
    word-wrap: break-word; /* 防止长文本溢出 */
    overflow-wrap: break-word;
  }
}

/* 超窄屏优化 */
@media (max-width: 420px) {
  .product-info {
    padding: 8px;
  }
  
  .product-image {
    max-width: 150px;
    margin-bottom: 12px;
  }
  
  .product-details h3 {
    font-size: 16px;
    margin-bottom: 8px;
  }
  
  .product-details p {
    font-size: 13px;
    margin: 6px 0;
  }
}

.image-error {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #151516;
  color: #909399;
}

.product-details h3 {
  margin: 0 0 10px 0;
  color: #409eff;
}

.product-details p {
  margin: 5px 0;
  font-size: 14px;
  color: #e0e0e0;
}

/* 表格区域 */
.table-card {
  background-color: #1e1e1e;
  border: 1px solid #2d2d2d;
}

.different-value {
  color: #f56c6c;
  font-weight: bold;
}

/* 表格深色样式 & 悬停效果 */
::v-deep .dark-table th {
  background-color: #1e1e1e;
  color: #e0e0e0;
  border-bottom: 1px solid #2d2d2d;
  border-right: 1px solid #2d2d2d;
  font-weight: bold;
}

::v-deep .dark-table td {
  background-color: #151516;
  color: #e0e0e0;
  border-bottom: 1px solid #2d2d2d;
  border-right: 1px solid #2d2d2d;
  transition: background-color 0.2s ease;
}

/* 表格行悬停 - 深色#030303 */
::v-deep .dark-table tr:hover > td {
  background-color: #030303;
  color: #ffffff;
}

/* 全屏弹窗样式 */
::v-deep .fullscreen-comparison-modal {
  padding: 0;
  background-color: #151516;
}

::v-deep .el-dialog__header {
  background-color: #1e1e1e;
  border-bottom: 1px solid #2d2d2d;
}

::v-deep .el-dialog__title {
  color: #e0e0e0;
  font-size: 16px;
}

::v-deep .el-dialog__body {
  padding: 20px;
  max-height: calc(100vh - 150px);
  overflow-y: auto;
  background-color: #151516;
}

/* 弹窗底部按钮区 */
.dialog-footer {
  text-align: center;
  padding: 15px 0;
  border-top: 1px solid #2d2d2d;
  background-color: #1e1e1e;
}

.close-btn {
  /*background-color: #2d2d2d;*/
  /*color: #e0e0e0;*/
  background-color: #006BFF;
  color: #FFFFFF;
  border: none;
}

::v-deep .el-icon-close {
  color: #e0e0e0;
}
</style>